import { useNavigate } from "react-router-dom";
import ProfileMenu from "./ProfileMenu";
import { Flex } from "antd";
import cleantec_logo from "../../../assets/png/cleantec_logo.png";
import cleantec_logo_svg from "../../../assets/svg/cleantec_logo.svg";
import myworkapp_icon from "../../../assets/myworkapp-icon.png";
import { Link } from "react-router-dom";
import { ClockCircleOutlined } from "@ant-design/icons";

function Navbar() {
  const navigate = useNavigate();
  return (
    <Flex
      justify="space-between"
      align="center"
      className="sticky top-0 z-10 w-full"
    >
      <Flex gap={"20px"} align="center" className="">
        <Link to={"/"} className="flex flex-shrink-0 items-center">
          <img
            src={myworkapp_icon}
            alt="MyWorkApp"
            className="w-16 p-2"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            onError={(e) => {
              e.currentTarget.src = `data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M12 8v8"/><path d="M8 12h8"/></svg>`;
            }}
          />
          <span
            className="hidden text-xl font-bold text-white sm:inline-block"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3, delay: 0.1 }}
          >
            MyWorkApp<span className="text-primary">.io</span>
          </span>
        </Link>
      </Flex>

      <div>
        <img src={cleantec_logo_svg} alt="cleantec logo" className="h-10" />
      </div>

      <Flex gap={"12px"} align="center" className="pr-6">
        <ClockCircleOutlined
          className="cursor-pointer text-2xl text-white"
          onClick={() => {
            navigate("/activities");
          }}
        />
        <ProfileMenu />
      </Flex>
    </Flex>
  );
}

export default Navbar;
